
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/audio-tools",
      function () {
        return require("private-next-pages/audio-tools.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/audio-tools"])
      });
    }
  